// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"a1c3e6d9","156":"e662e66c","431":"915d03f7","489":"a13f4860","608":"0eec6655","787":"b075c4f3","920":"6c327637"}[chunkId] + ".chunk.js";
};